import React from 'react';

import type { FlagProps } from '../src/types';

const FlagZm = ({ className, testID }: FlagProps) => (
  <svg
    width={20}
    height={15}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid={testID}
    className={className}
    aria-hidden="true"
  >
    <mask
      id="prefix__a"
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={20}
      height={15}
    >
      <path fill="#fff" d="M0 0h20v15H0z" />
    </mask>
    <g mask="url(#prefix__a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0h20v15H0V0z"
        fill="#F7FCFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0v15h20V0H0z"
        fill="#5EAA22"
      />
      <mask
        id="prefix__b"
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={20}
        height={15}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0v15h20V0H0z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#prefix__b)">
        <path fill="#FF8126" d="M16.25 6.25H20V15h-3.75z" />
        <path fill="#272727" d="M12.5 6.25h3.75V15H12.5z" />
        <path fill="#C51918" d="M8.75 6.25h3.75V15H8.75z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.51 1.948c.338.124 0 .315 0 .315s-.067-.078-.067-.143c0-.064-.26 0-.393.236-.127.223.107.222.352.221h.04c.14 0 .356-.013.558-.026.175-.011.34-.022.43-.022.196 0 .289 0 .547-.173.168-.113.723-.252 1.136-.355.223-.055.404-.1.46-.125.164-.073-.162.31-.162.31s1.257-.508 1.51-.681c.155-.107.084-.016-.03.133a3.7 3.7 0 0 0-.223.31c-.106.176.11.008.351-.178.129-.1.265-.205.361-.265.277-.173-.07.296-.223.443-.153.147.359 0 .536-.147.13-.107.011.081-.09.24-.035.057-.069.11-.087.144l-.003.006c-.069.125-.09.165.073.165.167 0-.429.463-.429.463s.178-.028 0 .28c-.105.182-.614.365-1.028.515-.288.103-.53.19-.555.249-.047.104-.51.224-.727.28-.077.02-.123.033-.107.033.061 0 .163.077.053.077-.11 0-.304.062-.304.062s.102 0 0 .145c-.049.07-.134.059-.194.051-.066-.008-.1-.013-.025.094.068.097.092.132.085.142-.01.012-.06-.009-.139-.009a.642.642 0 0 1-.224-.061.753.753 0 0 0-.273-.072c-.173 0 0 .123.11.2l.012.009c.097.069.057.068-.119.068h-.057a.911.911 0 0 1-.199-.019c-.033-.006-.036-.007-.036.019 0 .024-.082-.01-.18-.051-.103-.043-.223-.093-.288-.093-.129 0 .273.266.273.266s-.21-.068-.323-.122c-.064-.031.018.115.092.247.056.1.107.192.087.192a.333.333 0 0 1-.09-.036c-.08-.038-.181-.087-.181-.022 0 .096.092.168.205.168.114 0 .132.15.066.15-.024 0-.052-.01-.08-.019-.051-.018-.099-.035-.099.02 0 .034.02.06.044.09.032.042.07.092.07.182 0 .156-.169.178-.114.075.056-.104-.191-.353-.191-.231v.156c0 .11-.022.118-.055.129a.134.134 0 0 0-.073.05.216.216 0 0 0-.05.098c-.003.016-.004.02-.034.02-.023 0-.042-.035-.068-.081-.04-.071-.095-.17-.204-.216-.104-.043-.11-.012-.119.042-.007.04-.016.092-.068.136-.079.067-.057.094-.031.127.015.018.03.039.03.069 0 .083-.137-.083-.137-.196 0-.112-.157-.26-.157-.178 0 .083 0 .178-.08.178-.039 0-.04.028-.042.065-.002.04-.005.091-.056.13-.05.04-.049.019-.046-.027.002-.043.006-.11-.033-.168-.049-.073-.008-.185.013-.243.013-.036.018-.05-.013-.018-.078.083-.178.083-.246.083h-.002c-.034 0-.064.043-.085.074-.02.03-.033.049-.033.001 0-.096.1-.347.288-.347.145 0 .218-.06.28-.11a.637.637 0 0 1 .055-.041c.08-.051 0-.119-.08-.168-.037-.022-.024-.095.002-.16.045-.028.078-.064.078-.1 0-.044-.048.023-.078.1a.392.392 0 0 1-.179.064c-.043 0-.016-.078.018-.175a.892.892 0 0 0 .061-.254c0-.07.012-.133.02-.176.011-.055.016-.079-.02-.05-.043.038-.276-.003-.435-.03-.068-.012-.123-.022-.143-.022-.03 0-.006-.056.018-.111.03-.07.06-.14-.018-.096-.122.067-.369.064-.526.063h-.061c-.092 0-.029-.082.005-.125.019-.025.029-.037-.005-.015a.51.51 0 0 1-.292.077c-.047 0-.06-.028-.075-.059-.018-.037-.038-.079-.123-.078-.156.001-.19-.001-.276-.069-.045-.035-.02-.056-.006-.067.013-.011.017-.014-.05-.014h-.422c-.21 0 0-.164.076-.164s.164-.147 0-.08c-.104.041-.216.03-.349.016-.074-.008-.155-.017-.244-.017-.25 0-.297-.115-.15-.115s.156-.084-.073-.084c-.144 0-.262-.04-.35-.068a.433.433 0 0 0-.124-.031c-.08 0-.168-.114 0-.114.169 0 .384-.094.2-.094-.104 0-.277-.056-.428-.104-.116-.037-.219-.07-.266-.07-.037 0 .02-.012.096-.028.152-.033.378-.081.09-.081-.31 0-.633-.252-.856-.425a1.43 1.43 0 0 0-.215-.151c-.173-.08 0-.236.05-.17.05.064.4.164.248.077a.906.906 0 0 1-.298-.315c-.05-.08-.011-.135.05-.072.061.063.345.244.345.244s-.152-.172-.272-.442c-.12-.27.12-.204.326 0 .206.204.4.258.497.27.097.012-.097-.147-.284-.27-.187-.123-.144-.563 0-.387.075.091.431.265.78.436.32.157.634.31.716.393.14.143.027-.07-.095-.3l-.075-.142c-.081-.157.246.021.619.224.268.146.56.305.74.36.123.04.27.1.418.162.363.15.726.301.726.106 0-.276.333-.706.69-.852.226-.092.332-.009.466.096.078.06.164.129.287.174zm-.384 3.23c.08 0 .058-.836.058-.836s.238.513.238.735c0 .1-.007.13-.005.16.003.035.019.069.076.22.059.155.02.138-.086.092-.085-.036-.214-.092-.37-.092-.35 0 .008-.279.089-.279z"
          fill="#FF8126"
        />
      </g>
    </g>
  </svg>
);

export default FlagZm;
